module.exports = __webpack_public_path__ + "img/tg-qrcode.0e583145.png";